@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Mississippi</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>

      @if (controls?.length >= 1) {
        @if (baseRules?.RejectPD_LevelOne_Radio?.includes("Yes")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ textValues?.Rejects_Property_Damage_Text }}</label>
            </div>
          </div>
        }
      }

      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[1].formControlName)?.touched &&
            reactiveForm.get(controls[1].formControlName)?.invalid,
        }"
      >
        <!-- @if (baseRules?.Reject_PD_Text) {
        <div class="axis-form-group">
          <label class="axis-control-label">
            {{ textValues?.Reject_PD_Text }}
          </label>
        </div>
      } -->
        @if (controls?.length >= 2) {
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!-- @if (baseRules?.Reject_PD_Text) {
        <div class="axis-form-group">
          <label class="axis-control-label">
            {{ textValues?.Reject_PD_Text }}
          </label>
        </div>
      } -->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[2].formControlName)?.touched &&
            reactiveForm.get(controls[2].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 3) {
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>

      <div class="axis-grid">
        @for (control of controls | slice: 3 : 9; track $index) {
          @if (control.formControlName.startsWith("BIPD_") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}</label
                >
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                  (onSelect)="control.selectedPremium = $any($event).premium"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <div class="axis-grid">
        @for (control of controls | slice: 9; track $index) {
          @if (control.formControlName.startsWith("UMBI_") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}</label
                >
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                  (onSelect)="control.selectedPremium = $any($event).premium"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
        @if ((baseRules?.["UMBI_SplitMinLimits_DropDown"] ?? "").includes("readonly")) {
          <div class="axis-grid">
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[11].label }}</label>
                <div id="umbi_splitminlimits_25k_50k-pdffield-mississippi">
                  {{ controls[11].data[0]?.name }}
                </div>
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMBI_CombinedSingleMinLimit_DropDown"] ?? "").includes("readonly")) {
          <div class="axis-grid">
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[12].label }}</label>
                <div id="umbi_combinedsingleminlimit_50k-pdffield-mississippi">
                  {{ controls[12].data[0]?.name }}
                </div>
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["BIPD_CombinedSingleMinLimit_DropDown"] ?? "").includes("readonly")) {
          <div class="axis-grid">
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[8].label }}</label>
                <div id="bipd_combinedsingleminlimit_75k-pdffield-mississippi">
                  {{ controls[8].data[0]?.name }}
                </div>
              </div>
            </div>
          </div>
        }
        <div class="axis-grid">
        @if ((baseRules?.["BIPD_SplitMinLimits_BI_DropDown"] ?? "").includes("readonly")) {
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[6].label }}</label>
                <div id="bipd_splitminlimits_bi_25k_50k-pdffield-mississippi">
                  {{ controls[6].data[0]?.name }}
                </div>
              </div>
            </div>
        }
        @if ((baseRules?.["BIPD_SplitMinLimits_PD_DropDown"] ?? "").includes("readonly")) {
            <div class="axis-col-sm-6 axis-col-lg-4">
              <div class="axis-form-group">
                <label class="axis-control-label">{{ controls[7].label }}</label>
                <div id="bipd_splitminlimits_pd_25k-pdffield-mississippi">
                  {{ controls[7].data[0]?.name }}
                </div>
              </div>
            </div>
        }
        </div>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Mississippi</h2>
  @if (baseRules?.RejectUM_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Uninsured_Text }}
      </label>
    </div>
  }

  <div class="axis-grid">
    @if (baseRules?.UMBI_SplitMinLimits_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[11].label }} </label>
          <div>{{ controls[11].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.UMBI_CombinedSingleMinLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
         <label class="axis-control-label"> {{ controls[12].label }} </label>
          <div>{{ controls[12].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.["UMBILiabilityLimit_DropDown"]?.includes("show")) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[13].label }} </label>
          <div>{{ controls[13].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules?.["BIPDLiabilityLimit_DropDown"]?.includes("show")) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[14].label }} </label>
          <div>{{ controls[14].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
  @if (baseRules?.RejectPD_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Rejects_Property_Damage_Text }}
      </label>
    </div>
  }

}
